import { render, staticRenderFns } from "./addInsurancePayment.vue?vue&type=template&id=8b450076"
import script from "./addInsurancePayment.vue?vue&type=script&lang=js"
export * from "./addInsurancePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports